"use strict";

var _createForOfIteratorHelper = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Grabber = void 0;

var Utils_1 = require("../../Utils");

var Modes_1 = require("../../Enums/Modes");

var Grabber = /*#__PURE__*/function () {
  function Grabber(container) {
    _classCallCheck(this, Grabber);

    this.container = container;
  }

  _createClass(Grabber, [{
    key: "isEnabled",
    value: function isEnabled() {
      var container = this.container;
      var mouse = container.interactivity.mouse;
      var events = container.actualOptions.interactivity.events;

      if (!(events.onHover.enable && mouse.position)) {
        return false;
      }

      var hoverMode = events.onHover.mode;
      return Utils_1.Utils.isInArray(Modes_1.HoverMode.grab, hoverMode);
    }
  }, {
    key: "reset",
    value: function reset() {}
  }, {
    key: "interact",
    value: function interact() {
      var _a;

      var container = this.container;
      var options = container.actualOptions;
      var interactivity = options.interactivity;

      if (interactivity.events.onHover.enable && container.interactivity.status === Utils_1.Constants.mouseMoveEvent) {
        var mousePos = container.interactivity.mouse.position;

        if (mousePos === undefined) {
          return;
        }

        var distance = container.retina.grabModeDistance;
        var query = container.particles.quadTree.queryCircle(mousePos, distance);

        var _iterator = _createForOfIteratorHelper(query),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var particle = _step.value;
            var pos = particle.getPosition();
            var pointDistance = Utils_1.NumberUtils.getDistance(pos, mousePos);

            if (pointDistance <= distance) {
              var grabLineOptions = interactivity.modes.grab.links;
              var lineOpacity = grabLineOptions.opacity;
              var opacityLine = lineOpacity - pointDistance * lineOpacity / distance;

              if (opacityLine > 0) {
                var optColor = (_a = grabLineOptions.color) !== null && _a !== void 0 ? _a : particle.options.links.color;

                if (!container.particles.grabLineColor) {
                  var linksOptions = container.actualOptions.interactivity.modes.grab.links;
                  container.particles.grabLineColor = Utils_1.ColorUtils.getLinkRandomColor(optColor, linksOptions.blink, linksOptions.consent);
                }

                var colorLine = Utils_1.ColorUtils.getLinkColor(particle, undefined, container.particles.grabLineColor);

                if (colorLine === undefined) {
                  return;
                }

                container.canvas.drawGrabLine(particle, colorLine, opacityLine, mousePos);
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }]);

  return Grabber;
}();

exports.Grabber = Grabber;